export default "__VITE_ASSET__K9d0ln7M__"